import {useMemo} from 'react';
import type {GetValueById} from 'schema/form/types';
import type {Product} from 'services/metadata/types';

export const useManifestationDescription = (
  getEditValue: GetValueById,
  manifestationId: string,
): string | undefined => {
  const products = getEditValue('products', manifestationId) as
    | Product[]
    | undefined;

  return useMemo(() => {
    return products && products[0]
      ? (products?.[0]?.descriptions?.[0]?.content ?? undefined)
      : undefined;
  }, [products]);
};
